import { AuxToggle, AuxRadioGroup } from "@blk/aladdin-react-components-es";
import React from "react";
import { useDispatch } from "react-redux";
import { preview } from "common/constants";
import { useWidgetComponentProps, useWidgetCurrentGridSwitch } from "components/widgets/hooks/use-current-widget";
import { setCurrentGridSwitch } from "store/current-dashboard";
import { setWorkshopComponentProps } from "store/widget-workshop";
export const InsGridSwitcherToggle = (props) => {
    const dispatch = useDispatch();
    const compProps = useWidgetComponentProps(props.sectionId, props.widgetId), gridSwitcher = compProps?.gridSwitcher;
    const enabled = useWidgetCurrentGridSwitch(props.sectionId, props.widgetId);
    if ((!props.sectionId && !props.widgetId) || !gridSwitcher) {
        return React.createElement(React.Fragment, null);
    }
    const handleToggleChanged = (e) => {
        dispatch(setCurrentGridSwitch({
            enabled: Boolean(e.detail.value?.checked),
            sectionId: props.sectionId || "",
            widgetId: props.widgetId || ""
        }));
        if (props.sectionId === preview.sectionId && props.widgetId === preview.widgetId) {
            dispatch(setWorkshopComponentProps({ ...compProps, userSettings: { ...compProps?.userSettings, gridSwitch: Boolean(e.detail.value?.checked) } }));
        }
    };
    const handleRadioChanged = (e) => {
        const isEnabled = Boolean(e.detail.value?.uid === 0);
        dispatch(setCurrentGridSwitch({
            enabled: isEnabled,
            sectionId: props.sectionId || "",
            widgetId: props.widgetId || ""
        }));
        if (props.sectionId === preview.sectionId && props.widgetId === preview.widgetId) {
            dispatch(setWorkshopComponentProps({ ...compProps, userSettings: { ...compProps?.userSettings, gridSwitch: isEnabled } }));
        }
    };
    return gridSwitcher.type === "radio"
        ? React.createElement(AuxRadioGroup, { data: [
                {
                    checked: enabled,
                    disabled: false,
                    eventData: { checked: true },
                    label: gridSwitcher.left
                },
                {
                    checked: !enabled,
                    disabled: gridSwitcher.disabled === "right",
                    eventData: { checked: false },
                    label: gridSwitcher.right
                }
            ], label: gridSwitcher.name, onRadioChanged: handleRadioChanged })
        : React.createElement(AuxToggle, { slot: "target", label: gridSwitcher.name, size: props.small ? "small" : "regular", isChecked: enabled, onToggleChanged: handleToggleChanged });
};
